export default "__VITE_ASSET__Dam$OFfV__"